import React from "react";
import { Navigate } from "react-router-dom";

import { useGetMeQuery } from "redux/services/apiService";
import { selectUserPermissions } from "redux/slices/user";
import { useAppSelector } from "redux/store";

type Props = {};
const PrivateSettingUsers: React.FC<Props> = ({ children }): JSX.Element => {
    const selectPermission = useAppSelector(selectUserPermissions);
    const hasRoleUsers = selectPermission.some(item => item.includes('.users'));
    const { isLoading } = useGetMeQuery();
    if (isLoading) {
        return null;
    }

    if (!hasRoleUsers) {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};

export default PrivateSettingUsers;
